import React from "react";
import { Slide, Heading } from "spectacle";
import AlgorithmGraph from "../components/AlgorithmGraph";
import animations from "../util/animations";
import { f, df, x, y, x0 } from "../util/function";
import InteractiveAlgorithm from "../components/InteractiveAlgorithm";

const points = [];
for (let i = 0; i < 5; ++i) {
  let x = x0;
  if (i > 0) {
    x = points[points.length - 1].x;
    x -= f(x) / df(x);
  }
  points.push({
    x,
    length: 1.1 * Math.abs(f(x) / df(x))
  });
}

class TrailedGraph extends React.Component {
  length = 30000;
  count = 32;
  state = {
    points: [-1, 0, 1]
  };
  lastPoint = -100;
  constructor(...args) {
    super(...args);

    this.addPoint = t => {
      if (t - this.lastPoint > 2.2 / this.count) {
        this.lastPoint = t;
        this.setState({ points: [t, ...this.state.points] });
      }
    };
  }

  componentDidMount() {
    animations.add(this.addPoint, {
      length: this.length,
      min: -1.1,
      max: 1.1,
      ease: animations.easing.cubic
    });
  }
  componentWillUnmount() {
    animations.remove(this.addPoint);
  }
  render() {
    return (
      <InteractiveAlgorithm
        frames={[-1.1, 1.1]}
        repeat={true}
        color={true}
        wait={[this.length, 10000]}
        points={this.state.points}
      />
    );
  }
}

export default [
  ...[[1, 0], [1, 1], [2, 0], [2, 1], [3, 1], [4, 0]].map(([i, step]) => (
    <Slide>
      <div style={{ position: "relative" }}>
        <AlgorithmGraph
          f={f}
          df={df}
          x={x}
          y={y}
          points={points.slice(0, i).map((d, j) => {
            return {
              ...d,
              step: j + 1 === i ? step : 2
            };
          })}
        />
        <div style={{ position: "absolute", top: 0, width: "100%" }}>
          <Heading size={2}>Nulpunten?</Heading>
        </div>
      </div>
    </Slide>
  )),
  <Slide>
    <InteractiveAlgorithm frames={[x0, -0.487]} wait={[20000]} />
  </Slide>,
  <Slide>
    <InteractiveAlgorithm frames={[-0.487, -1.1]} wait={[15000]} />
  </Slide>,
  <Slide>
    <InteractiveAlgorithm
      frames={[-1.1]}
      repeat={true}
      color={true}
      points={[-1, 0, 1]}
    />
  </Slide>,
  <Slide>
    <TrailedGraph />
  </Slide>
];
